import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './styles.css';

class Slide extends Component {
  /**************
   * Properties *
   **************/

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    var classString = this.props.show ? 'slide-visible' : 'slide-hide';
    return (
      <div className={classString}>
        <img src={this.props.image} alt="" />
      </div>
    );
  }
}

export default withRouter(Slide);
